<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="content-wrapper">
      <div class="page-header">{{ $t('remark') }}</div>
      <div style="margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'HotelRemark' }">{{ $t('remark') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('editRemark') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-container>
        <el-main>
          <el-form ref="form"  label-width="0">
            <div class="el-form-item el-form-item__content">
              <editor-component v-model="editorContent"></editor-component>
            </div>
            <el-form-item label="">
              <el-button type="primary" @click="onSaveButtonClick">{{ $t('save') }}</el-button>
              <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
            </el-form-item>
          </el-form>
        </el-main>
      </el-container>
    </div>
  </ContentContainer>
</template>

<script>
import { get, isEmpty } from 'lodash'
import i18nMessages from '@/translations/Hotel/ManageHotel/Remark/Edit.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import HotelApi from '@/api/hotel-api'
import ContentContainer from '@/components/ContentContainerComponent.vue'
import EditorComponent from '@/components/EditorComponent'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { getHotelIndexRoute } from '@/services/hotel-service'

export default {
  name: 'HotelRemarkEdit',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer, EditorComponent },
  i18n: { messages: i18nMessages },
  props: {
    hotel: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  created: async function () {
    if (!this.hotel || isEmpty(this.hotel)) {
      const companyDetail = LocalStorageFactory.getCompanyDetail()
      const routeName = await getHotelIndexRoute(companyDetail, this.$store)

      return this.$router.push({
        name: routeName
      })
    }

    this.editorContent = get(this.hotel, 'remark', '')
    this.isLoading = false
  },
  data () {
    return {
      editorContent: '',
      isLoading: true
    }
  },
  methods: {
    onSaveButtonClick: async function () {
      try {
        this.startLoading()

        const hotel = {
          remark: this.editorContent
        }
        const hotelData = Object.assign({}, this.hotel, hotel)
        await HotelApi.update(this.hotel.id, hotelData)

        const title = this.$t('saveRemarkSuccessTitle')
        const message = this.$t('saveRemarkSuccessMessage')

        this.showNotificationSuccess(title, message)
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
      this.$router.push({
        name: 'HotelRemark'
      })
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'HotelRemark'
      })
    }
  }
}
</script>

<style scoped>
  .el-header {
    background-color: #f8f9fa;
    color: #2c3e50;
    text-align: left;
    min-height: 60px;
    font-size: 14px;
    padding-top: 10px;
  }
  .edit-remark {
    margin-top: 20px;
  }

  .el-form-item__content {
    line-height: 22px;
  }
</style>
